import { i18n } from "../../../../../i18n-config";

/**
 * Push one event object onto GTM's `dataLayer`.
 *
 * `dataLayer` is a QUEUE, and that is the whole point of it: pushes made before the
 * container script finishes loading sit in the array, and GTM replays them when it
 * initialises. So we create the array if it is not there yet and always push.
 *
 * This matters much more than it used to. Every tag is now `lazyOnload` and behind
 * the idle gate (see `tagGate.ts`), which stretched the window between first paint
 * and `gtm.js` executing from milliseconds to seconds. Anything that dropped an
 * event during that window — an early add-to-cart, a search, a login — lost it for
 * good. Never gate a push on `window.google_tag_manager`: that is a load-COMPLETION
 * signal, not a "should we track this" signal.
 *
 * Replaces `TagManager.dataLayer({ dataLayer: X })` from `react-gtm-module`, which
 * did the same thing (and also created the array when absent) before that dependency
 * was removed.
 */
const dataLayer = (): unknown[] => {
  const w = window as unknown as { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer || [];
  return w.dataLayer;
};

export const pushToDataLayer = (data: Record<string, unknown>) => {
  if (typeof window === "undefined") return;
  dataLayer().push(data);
};

export const pageview = (url: string) => {
  if (typeof window === "undefined") return;
  pushToDataLayer({
    event: "pageview",
    page: url,
    pageTitle: document.title,
  });
  if (isHomePage(url)) {
    pushToDataLayer({
      event: "home_page",
      page: url,
      pageTitle: document.title,
    });
  }
};
const isHomePage = (url: string) => {
  const urlTerms = url.split("/");
  if (urlTerms.length === 2 && ["", ...i18n.locales].includes(urlTerms[1]))
    return true;
  return false;
};
